import React from "react";
import styled from "styled-components";
import { style } from "../style";
import { ItemizedSummaryTotals } from "./types";

const Container = styled.div`
  all: unset;
  width: 100%;
  box-sizing: border-box;

  display: flex;
  gap: 14px;
`;

const TitleWrapper = styled.div<{ $centered: boolean }>`
  all: unset;
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;

  ${(props) => {
    if (props.$centered) {
      return {
        flexWrap: "wrap",
        alignContent: "center",
      };
    }
  }}
`;

const Title = styled.span`
  all: unset;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  color: ${style.colors.grey.darkest};
  font-weight: ${style.vars.fontWeight.bold};
`;

const Subtitle = styled.span`
  all: unset;
  color: ${style.colors.grey.dark};
  font-size: ${style.vars.fontSize.small};
`;

const TotalWrapper = styled.div`
  all: unset;

  display: flex;
  flex-direction: column;
  align-items: flex-end;

  flex-grow: 0;
`;

const Amount = styled.span`
  all: unset;
  display: inline;
  font-weight: ${style.vars.fontWeight.bold};
  color: ${style.colors.grey.darkest};
`;

type Props = {
  totals: ItemizedSummaryTotals;
  centered: boolean;
};

export const ItemizedGrandTotal: React.FC<Props> = (props) => {
  const { totals, centered } = props;
  const { title, amounts } = totals;

  return (
    <Container>
      <TitleWrapper $centered={centered}>
        <Title>{title}</Title>
      </TitleWrapper>
      <TotalWrapper>
        {amounts.map((total) => {
          const unit = total.unit ? `/${total.unit}` : "";

          let dataPrice = title.toLowerCase().replace(" ", "-");

          if (total.unit) {
            dataPrice += `-per-${total.unit.toLowerCase().replace(" ", "-")}`;
          }

          if (total.type === "primary") {
            return (
              <span data-testid={dataPrice} data-price={dataPrice} key={`${total.amount}${unit}`}>
                <Amount>{total.amount}</Amount>
                {unit}
              </span>
            );
          } else {
            return (
              <Subtitle data-testid={dataPrice} data-price={dataPrice} key={`${total.amount}${unit}`}>
                {total.amount}
                {unit}
              </Subtitle>
            );
          }
        })}
      </TotalWrapper>
    </Container>
  );
};

ItemizedGrandTotal.displayName = "ItemizedGrandTotal";
